import { css, keyframes } from '@emotion/react'
import { typo } from '@mathflat/common/style'

// 드롭다운 등장 — 같은 GNB 슬롯을 쓰는 SubjectSwitch 와 동일한 모션
const popIn = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-6px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`

const S = {
  wrap: css`
    position: relative;
    display: inline-flex;
    // 드롭다운이 아래 페이지 콘텐츠 위에 그려지도록 끌어올린다.
    z-index: 100;
  `,
  trigger: css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    box-sizing: border-box;
    height: 36px;
    padding: 0 12px;
    border-radius: var(--Radius-200);
    background-color: var(--White);
    color: var(--Colors-Gray-900);
    ${typo.body02};
    white-space: nowrap;
    // 테두리를 border 가 아니라 inset 그림자로 그린다. 시안의 열림 상태는 바깥 3px + 안쪽 1px
    // 두 겹인데, border 로 두께를 바꾸면 36px 안에서 콘텐츠 상자가 줄어 라벨이 밀린다.
    box-shadow: inset 0 0 0 1px var(--Colors-Gray-300);
    transition:
      background-color 0.15s,
      box-shadow 0.15s;

    &:hover {
      background-color: var(--Colors-Gray-100);
    }

    svg {
      transition: transform 0.2s ease-in-out;
    }

    &.opened {
      box-shadow:
        inset 0 0 0 3px var(--Colors-Sky-100),
        inset 0 0 0 4px var(--Colors-Sky-400);
    }

    &.opened svg {
      transform: rotate(-180deg);
    }
  `,
  menu: css`
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    z-index: 100;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    // 시안의 고정 폭이다. 긴 학원명은 줄바꿈이 아니라 overflow 로 잘린다.
    width: 240px;
    // 소속 학원 수에 상한이 없어 목록이 화면 밖으로 자랄 수 있다.
    max-height: 316px;
    // 위쪽 여백은 sticky 헤더가 직접 갖는다. 컨테이너가 쥐고 있으면 스크롤된 행이 헤더
    // 위 여백 띠에 비친다.
    padding: 0 10px 10px;
    border: 1px solid var(--Colors-Gray-300);
    border-radius: var(--Radius-200);
    background-color: var(--White);
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.2);
    overflow-x: hidden;
    overflow-y: auto;
    // 더 있다는 것은 마지막 행이 걸쳐 보이는 것으로 드러난다.
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }

    animation: 0.16s ease-out ${popIn};
  `,
  menuHeader: css`
    ${typo.caption01};
    position: sticky;
    top: 0;
    // 스크롤된 행이 비치지 않게 바탕을 깐다.
    background-color: var(--White);
    padding: 18px 10px 8px;
    color: var(--Colors-Gray-600);
  `,
  item: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    background-color: var(--White);
    text-align: left;
    white-space: nowrap;
    cursor: default;

    &.actionable {
      cursor: pointer;
    }

    &.actionable:hover {
      background-color: var(--Colors-Gray-100);
    }

    &:disabled {
      cursor: not-allowed;
    }
  `,
  itemText: css`
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    // 학원명이 길면 이름 쪽만 줄어 배지·chevron 이 밀리지 않는다.
    min-width: 0;
  `,
  academyName: css`
    ${typo.body02};
    font-weight: 700;
    color: var(--Colors-Gray-900);
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
  unavailableReason: css`
    ${typo.caption01};
    color: var(--Colors-Gray-600);
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
  triggerLabel: css`
    max-width: 182px;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
  itemAside: css`
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    gap: 4px;
  `,
}

export default S
